import moment, { Moment } from 'moment';
import { DateTimeFormat } from '../store/mst/models';
import { twelveHrsMinFormat, hrsMinFormat } from '../constants';

const getFormattedTime = (time: Moment | undefined, format: any): string | undefined => (format === DateTimeFormat.MILITARY
  ? moment(time).format(hrsMinFormat) : moment(time).format(twelveHrsMinFormat));

export default getFormattedTime;
